module.exports = __webpack_public_path__ + "assets/icons/list-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/list-icon.png
// module id = ./src/styles/icons/sidemenu/list-icon.png
// module chunks = 0